var projectCtrl = (function () {
  return {
    project: function ($scope, Api, NgTableParams, ReqAndUpload, $q, $translate) {
      var change = false;
      $scope.$watch('project.welcome_message.persona', function (oldValue, newValue) {
        var isUndefined = typeof newValue === 'undefined' || typeof oldValue === 'undefined';
        if (change) {
          return;
        }
        if (isUndefined) {
          return;
        }
        if (oldValue._id === newValue._id) {
          return;
        }
        change = true;
        var index = $scope.project.admins.findIndex((x) => x._id === newValue._id);
        $scope.project.welcome_message.persona = $scope.project.admins[index];
      });

      $scope.languages = [
        {
          title: 'PT',
          value: 'pt-br'
        },
        {
          title: 'EN',
          value: 'en'
        }
      ];

      $translate('GLOBAL.LANGUAGE_TITLE_PT').then(function (result) {
        $scope.languages[0].title = result;
      });

      $translate('GLOBAL.LANGUAGE_TITLE_EN').then(function (result) {
        $scope.languages[1].title = result;
      });

      $scope.preSave = function (data) {
        if (data.domain) {
          data.domain = data.domain.replace(/(^([ ]*)?(http[s]?:\/\/)?(www\.)?)|[ ]*$/g, '');
        }
      };
    },

    colors: function ($scope, Api, NgTableParams, ReqAndUpload, $q, $translate) {
      $scope.colors = {
        primary: '42A5F5',
        secondary: '1976D2',
        header: 'FFFFFF',
        headerIcon: 'A0A0A0'
      };

      var pickerS, pickerP, pickerH, pickerI;
      var changeColors = function (mode, color) {
        $(`.${mode}-bg`).css('background-color', '#' + color.replace(/#/, ''));

        function convertHex(hex, opacity) {
          hex = hex.replace('#', '');
          let r = parseInt(hex.substring(0, 2), 16);
          let g = parseInt(hex.substring(2, 4), 16);
          let b = parseInt(hex.substring(4, 6), 16);
          return 'rgba(' + r + ',' + g + ',' + b + ',' + opacity / 100 + ')';
        }

        if (mode == 'primary') {
          $('.primary-bg.bg-light').css('background-color', convertHex(color, 90));
        }

        if (mode == 'header') {
          $('.header-bg').css('background-color', '#' + color.replace(/#/, ''));
        }

        if (mode == 'headerIcon') {
          $('.header-text').css('color', '#' + color.replace(/#/, ''));
          $('.header-bg').css('color', '#' + color.replace(/#/, ''));
        }

        $(`.${mode}-bg-hover`).hover(
          function () {
            $(this).css('background-color', '#' + color.replace(/#/, ''));
          },
          function () {
            $(this).css({
              'background-color': 'transparent'
            });
          }
        );

        $(`.${mode}-border`).css('border-color', '#' + color.replace(/#/, ''));
        $(`.${mode}-border-hover`).hover(
          function () {
            $(this).css('border-color', '#' + color.replace(/#/, ''));
          },
          function () {
            $(this).css({
              'border-color': '#A0A0A0'
            });
          }
        );

        $(`.${mode}-bg`).css('border', '');

        if (color.toLowerCase() === 'ffffff') {
          $(`.${mode}-bg`).css('border', '1px solid #A8A8A8');
        }

        $(`.set-${mode}`).val(color);
      };
      var updateP = function () {
        pickerP.set('#' + this.value.replace(/#/g, '')).enter();
      };
      var updateS = function () {
        pickerS.set('#' + this.value.replace(/#/g, '')).enter();
      };
      var updateH = function () {
        pickerH.set('#' + this.value.replace(/#/g, '')).enter();
      };
      var updateI = function () {
        pickerI.set('#' + this.value.replace(/#/g, '')).enter();
      };

      // Get appearance data
      Api.get(`project/${$scope.project_data.key}/appearance`, function (err, resp) {
        if (!err) {
          $scope.appearance = resp.response.data;
          $scope.colors.primary = resp.response.data.primary_color.replace(/#/, '');
          $scope.colors.secondary = resp.response.data.secondary_color.replace(/#/, '');
          $scope.colors.header = resp.response.data.header_color.replace(/#/, '');
          $scope.colors.headerIcon = resp.response.data.header_color_icon.replace(/#/, '');
          pickerP = new CP(document.querySelector('#firstcolor'));
          pickerP.set('#' + $scope.colors.primary.replace(/#/g, ''));
          pickerP.on('change', function (color) {
            this.target.value = color;
            $scope.colors.primary = color;
            changeColors('primary', color);
          });
          pickerP.target.oncut = updateP;
          pickerP.target.onpaste = updateP;
          pickerP.target.onkeyup = updateP;
          pickerP.target.oninput = updateP;

          pickerS = new CP(document.querySelector('#secondcolor'));
          pickerS.set('#' + $scope.colors.secondary.replace(/#/g, ''));
          pickerS.on('change', function (color) {
            this.target.value = color;
            $scope.colors.secondary = color;
            changeColors('secondary', color);
          });
          pickerS.target.oncut = updateS;
          pickerS.target.onpaste = updateS;
          pickerS.target.onkeyup = updateS;
          pickerS.target.oninput = updateS;

          pickerH = new CP(document.querySelector('#headercolor'));
          pickerH.set('#' + $scope.colors.header.replace(/#/g, ''));
          pickerH.on('change', function (color) {
            this.target.value = color;
            $scope.colors.header = color;
            changeColors('header', color);
          });
          pickerH.target.oncut = updateH;
          pickerH.target.onpaste = updateH;
          pickerH.target.onkeyup = updateH;
          pickerH.target.oninput = updateH;

          pickerI = new CP(document.querySelector('#headercolorIcon'));
          pickerI.set('#' + $scope.colors.headerIcon.replace(/#/g, ''));
          pickerI.on('change', function (color) {
            this.target.value = color;
            $scope.colors.headerIcon = color;
            changeColors('headerIcon', color);
          });
          pickerI.target.oncut = updateI;
          pickerI.target.onpaste = updateI;
          pickerI.target.onkeyup = updateI;
          pickerI.target.oninput = updateI;
        }
      });

      $scope.change = function (primary, secondary, header) {
        $scope.colors.primary = primary;
        $scope.colors.secondary = secondary;
        $scope.colors.header = header;
        $scope.colors.headerIcon = 'A0A0A0';
        changeColors('primary', primary);
        changeColors('secondary', secondary);
        changeColors('header', header);
        changeColors('headerIcon', 'A0A0A0');
      };

      // Save colors and generate new css
      $scope.save = function (colors) {
        $translate('PROJECT.COLORS_WAIT_TO_APPLY').then(function (result) {
          App.toast(result, Infinity);
        });
        $scope.appearance.primary_color = '#' + colors.primary;
        $scope.appearance.secondary_color = '#' + colors.secondary;
        $scope.appearance.header_color = '#' + colors.header;
        $scope.appearance.header_color_icon = '#' + colors.headerIcon;
        Api.put(`project/${$scope.project_data.key}/appearance`, $scope.appearance, function (err) {
          if (!err) {
            document.querySelectorAll('.toast').forEach((el) => el.remove());
            if (!err) {
              $translate('PROJECT.COLORS_SAVE_SUCCESS').then(function (result) {
                App.toast(result, 3000);
              });
            }
          }
        });
      };
    },

    dashboard: function ($scope, Api, NgTableParams, ReqAndUpload, $q, $translate) {
      $scope.dashboard = {};
      $scope.popular_tags = [];
      $scope.list_pending_articles = [];
      $scope.billing = {};

      // Get dashboard counters
      Api.get('analytics/dashboard', function (err, data) {
        if (!err) {
          $scope.dashboard = data.response;
        }
      });

      // Get popular tags
      Api.get('tag/counter?filter=POPULAR', function (err, data) {
        if (!err) $scope.popular_tags = data.response;
      });

      // // Get blogs
      if ($scope.project_data.plan.post_types_feature_enabled) {
        Api.get('blogs/get?all=ALL&page_size=4&sort=created', function (err, data) {
          if (!err)
            $scope.blogs = new NgTableParams(
              {},
              {
                counts: [],
                dataset: data.response
              }
            );
        });
      }

      // Get courses
      if ($scope.project_data.plan.courses_feature_enabled) {
        Api.get('course?scope=all&return_as=list&page_size=4&page=1&status=1', function (err, data) {
          if (!err)
            $scope.courses = new NgTableParams(
              {},
              {
                counts: [],
                dataset: data.response.data
              }
            );
        });
      }

      // // Get last 6 signed users
      Api.get(`user/list?signup_pending=false&page=1&page_size=6&sort_field=projects.${_bcp}.created&sort_order=DESC&only_profile=true`, function (err, ret) {
        if (!err) {
          var user_list = ret.response.data;
          for (var i = 0; i < user_list.length; i++) {
            var objDate = user_list[i].projects[_bcp].created ? new Date(user_list[i].projects[_bcp].created) : new Date(user_list[i].updated);
            user_list[i].created = objDate.toISOString();
          }
          $scope.list_signed_users = new NgTableParams(
            {},
            {
              counts: [],
              dataset: user_list
            }
          );
        }
      });

      // // Get last 4 published articles
      Api.get('article/list?mode=ALL&page=1&page_size=4&sort_field=publish&sort_order=DESC&status=PUBLISHED', function (err, data) {
        if (!err) {
          var article_list = data.response.data;
          for (var i = 0; i < article_list.length; i++) {
            var objDate = new Date(article_list[i].publish);
            article_list[i].publish = objDate.toISOString();
          }
          $scope.list_published_articles = new NgTableParams(
            {},
            {
              counts: [],
              dataset: article_list
            }
          );
        }
      });

      // // Get signups
      var objDate = new Date();
      var today = objDate.toISOString();
      var last1 = new Date(objDate.setDate(objDate.getDate() - 1)).toISOString();
      var last2 = new Date(objDate.setDate(objDate.getDate() - 1)).toISOString();
      var last3 = new Date(objDate.setDate(objDate.getDate() - 1)).toISOString();
      var last4 = new Date(objDate.setDate(objDate.getDate() - 1)).toISOString();
      var last5 = new Date(objDate.setDate(objDate.getDate() - 1)).toISOString();
      var last6 = new Date(objDate.setDate(objDate.getDate() - 1)).toISOString();
      var last7 = new Date(objDate.setDate(objDate.getDate() - 1)).toISOString();
      var last14 = new Date(objDate.setDate(objDate.getDate() - 7)).toISOString();

      Api.get(`analytics/counters?axis=signups&begin=${last7}&end=${today}`, function (err, resp) {
        if (!err) $scope.signups_day = resp.response / 7;
      });
      Api.get(`analytics/counters?axis=signups&begin=${last14}&end=${last7}`, function (err, resp) {
        if (!err) $scope.signups_last_week_by_day = resp.response / 7;
      });

      var columns = [['date'], ['Cadastros']];

      var signups_chart = c3.generate({
        bindto: '#graph-signups',
        data: {
          x: 'date',
          columns: columns,
          type: 'bar'
        },
        legend: {
          show: false
        },
        axis: {
          x: {
            show: false,
            type: 'timeseries',
            tick: {
              format: '%d/%m'
            }
          },
          y: {
            show: false
          }
        },
        size: {
          height: 120
        }
      });

      Api.get(`analytics/counters?axis=signups&begin=${today.split('T')[0] + 'T00:00:01.000Z'}&end=${today.split('T')[0] + 'T23:59:59.000Z'}`, function (err, resp) {
        if (!err) {
          columns[0].push(today.split('T')[0]);
          columns[1].push(resp.response);
          signups_chart.load({
            columns: columns
          });
        }
      });
      Api.get(`analytics/counters?axis=signups&begin=${last1.split('T')[0] + 'T00:00:01.000Z'}&end=${last1.split('T')[0] + 'T23:59:59.000Z'}`, function (err, resp) {
        if (!err) {
          columns[0].push(last1.split('T')[0]);
          columns[1].push(resp.response);
          signups_chart.load({
            columns: columns
          });
        }
      });
      Api.get(`analytics/counters?axis=signups&begin=${last2.split('T')[0] + 'T00:00:01.000Z'}&end=${last2.split('T')[0] + 'T23:59:59.000Z'}`, function (err, resp) {
        if (!err) {
          columns[0].push(last2.split('T')[0]);
          columns[1].push(resp.response);
          signups_chart.load({
            columns: columns
          });
        }
      });
      Api.get(`analytics/counters?axis=signups&begin=${last3.split('T')[0] + 'T00:00:01.000Z'}&end=${last3.split('T')[0] + 'T23:59:59.000Z'}`, function (err, resp) {
        if (!err) {
          columns[0].push(last3.split('T')[0]);
          columns[1].push(resp.response);
          signups_chart.load({
            columns: columns
          });
        }
      });
      Api.get(`analytics/counters?axis=signups&begin=${last4.split('T')[0] + 'T00:00:01.000Z'}&end=${last4.split('T')[0] + 'T23:59:59.000Z'}`, function (err, resp) {
        if (!err) {
          columns[0].push(last4.split('T')[0]);
          columns[1].push(resp.response);
          signups_chart.load({
            columns: columns
          });
        }
      });
      Api.get(`analytics/counters?axis=signups&begin=${last5.split('T')[0] + 'T00:00:01.000Z'}&end=${last5.split('T')[0] + 'T23:59:59.000Z'}`, function (err, resp) {
        if (!err) {
          columns[0].push(last5.split('T')[0]);
          columns[1].push(resp.response);
          signups_chart.load({
            columns: columns
          });
        }
      });
      Api.get(`analytics/counters?axis=signups&begin=${last6.split('T')[0] + 'T00:00:01.000Z'}&end=${last6.split('T')[0] + 'T23:59:59.000Z'}`, function (err, resp) {
        if (!err) {
          columns[0].push(last6.split('T')[0]);
          columns[1].push(resp.response);
          signups_chart.load({
            columns: columns
          });
        }
      });
    },

    digest: function ($scope, Api) {
      var report = function (month) {
        if (!$scope.project_data.plan.analytics_feature_enabled) return false;
        Api.get(`analytics/digests?month=${month}`, function (err, resp) {
          if (!err) {
            $scope.month_counters = resp.response.totals;
            $scope.month_digests = resp.response.analytics;
            $scope.month_counters.click_rate = ($scope.month_counters.clicks_count * 100) / $scope.month_counters.users_count;
          } else {
            $scope.month_counters = false;
            $scope.month_digests = false;
          }
        });
      };
      $scope.$watch('month', function (month) {
        if (month && $scope.project_data.plan.analytics_feature_enabled) report(month);
      });
    },

    home: function ($scope, Api, NgTableParams, ReqAndUpload, $q, $translate) {
      $scope.homeCb = function () {
        var path = `https://${_bcp}.redesign.static-01.com`;
        if (!$scope.banner) $scope.banner = {};
        if ($scope.banner.image) $scope.banner.url_image = `${path}/l/images/${$scope.banner.image}`;
        else $scope.banner.url_image = 'https://56e9af4bb89f1d73465cbd39.redesign.static-01.com/images/66e30a7b4b7c338c3caa312eb7ee8dd513c5f953.png';
        if ($scope.banner.image_mobile) $scope.banner.url_image_mobile = `${path}/l/images/${$scope.banner.image_mobile}`;
        if (!$scope.banner.url) $scope.banner.link = 0;
        else if ($scope.banner.url == '/signup') $scope.banner.link = 1;
        else {
          $scope.banner.link = 2;
          $scope.banner.external_url = $scope.banner.url;
        }
        $scope.banner.alignment = $scope.banner.alignment ? $scope.banner.alignment : 'left';
        $scope.banner.text_size = $scope.banner.text_size ? $scope.banner.text_size : 48;
      };

      $scope.preSave = function (banner) {
        // if(banner.link==0)  {
        //   banner.url = '';
        // } else if(banner.link==1) {
        //   banner.url = '/signup';
        // } else banner.url = banner.external_url;

        // Fix link to signup
        banner.url = '/signup';
        banner.link = 1;

        delete banner.external_url;
        delete banner.url_image;
        delete banner.url_image_mobile;
      };

      $scope.posSave = function () {
        $scope.loadData('project/banner', 'banner', 'response.banner', $scope.homeCb);
        $translate('PROJECT.BANNER_UPDATE_SUCCESS').then(function (result) {
          App.toast(result, 3000);
        });
      };
    },

    integrations: function ($scope, Api, NgTableParams, ReqAndUpload, $q, $translate, $http, $routeParams, formNotify) {
      $scope.integrations = {
        facebook_app_id: null,
        google_analytics: null,
        google_console_verification_code: null,
        google_tag_manager: null,
        iugu_connected_account: null,
        linkedin_organization_id: null,
        mailchimp_list_id: null,
        mailchimp_token: null,
        rdstation_monitoring_code: null,
        rdstation_token: null,
        stripe_connected_account: null
      };

      $scope.mailchimpList = [];
      $scope.saving = false;

      $scope.list = [
        {
          title: 'Google Analytics',
          modal: '#modal-analytics',
          status: false
        },
        {
          title: 'Google tag Manager',
          modal: '#modal-tagmanager',
          status: false
        },
        {
          title: 'Google Console',
          modal: '#modal-console',
          status: false
        },
        {
          title: 'RDStation',
          modal: '#modal-rdstation',
          status: false
        },
        {
          title: 'MailChimp',
          modal: '#modal-mailchimp',
          status: false
        },
        {
          title: 'Linkedin',
          modal: '#modal-linkedin',
          status: false
        }
      ];

      $scope.open = function (obj) {
        $(obj).openModal();
      };

      // Get integrations
      Api.get('integrations/google-analytics', function (err, resp) {
        if (!err) {
          $scope.integrations.google_analytics = resp.response.data;
          $scope.list[0].status = $scope.integrations.google_analytics ? true : false;
        }
      });

      Api.get('integrations/google-tag-manager', function (err, resp) {
        if (!err) {
          $scope.integrations.google_tag_manager = resp.response.data;
          $scope.list[1].status = $scope.integrations.google_tag_manager ? true : false;
        }
      });

      Api.get('integrations/google-console', function (err, resp) {
        if (!err) {
          $scope.integrations.google_console_verification_code = resp.response.data;
          $scope.list[2].status = $scope.integrations.google_console_verification_code ? true : false;
        }
      });

      Api.get('integrations/rdstation', function (err, resp) {
        if (!err) {
          $scope.integrations.rdstation_token = resp.response.data.token;
          $scope.integrations.rdstation_monitoring_code = resp.response.data.monitoring_code;
          $scope.list[3].status = $scope.integrations.rdstation_token ? true : false;
        }
      });

      Api.get('integrations/mailchimp', function (err, resp) {
        if (!err) {
          $scope.integrations.mailchimp_token = resp.response.data.token;
          $scope.integrations.mailchimp_list_id = resp.response.data.list_id || '';
          $scope.list[4].status = $scope.integrations.google_console_verification_code ? true : false;
          $scope.onChangeMailChimpToken($scope.integrations.mailchimp_token);
        }
      });

      Api.get('integrations/linkedin', function (err, resp) {
        if (!err) {
          $scope.integrations.linkedin_organization_id = resp.response.data;
          $scope.list[5].status = $scope.integrations.linkedin_organization_id ? true : false;
        }
      });

      // Save integrations

      $scope.saveLinkedin = function (organizationId) {
        const data = {
          organization_id: organizationId
        };
        $scope.saving = true;
        Api.post('integrations/linkedin', data, function (err, resp) {
          if (!err) {
            $scope.integrations.linkedin_organization_id = organizationId;
            $translate('PROJECT.SAVE_SUCCESS').then(function (result) {
              App.toast(result, 3000);
            });
          }
          $scope.saving = false;
          $('.modal.open .modal-close').trigger('click');
        });
      };

      $scope.saveRdstation = function (code, monitoring_code) {
        const data = {
          token: code,
          monitoring_code: monitoring_code
        };
        $scope.saving = true;
        Api.put('integrations/rdstation', data, function (err, resp) {
          if (!err) {
            $scope.integrations.rdstation_token = code;
            $translate('PROJECT.SAVE_SUCCESS').then(function (result) {
              App.toast(result, 3000);
            });
          }
          $scope.saving = false;
          $('.modal.open .modal-close').trigger('click');
        });
      };

      $scope.saveGoogleAnalytics = function (token) {
        const data = {
          token: token
        };
        $scope.saving = true;
        Api.put('integrations/google-analytics', data, function (err, resp) {
          if (!err) {
            $scope.integrations.google_analytics = token;
            $translate('PROJECT.SAVE_SUCCESS').then(function (result) {
              App.toast(result, 3000);
            });
          }
          $scope.saving = false;
          $('.modal.open .modal-close').trigger('click');
        });
      };

      $scope.saveGoogleTagManager = function (token) {
        const data = {
          token: token
        };
        $scope.saving = true;
        Api.put('integrations/google-tag-manager', data, function (err, resp) {
          if (!err) {
            $scope.integrations.google_tag_manager = token;
            $translate('PROJECT.SAVE_SUCCESS').then(function (result) {
              App.toast(result, 3000);
            });
          }
          $scope.saving = false;
          $('.modal.open .modal-close').trigger('click');
        });
      };

      $scope.saveMailchimp = function (token, list_id) {
        const data = {
          token: token,
          list_id: list_id
        };
        $scope.saving = true;
        Api.put('integrations/mailchimp', data, function (err, resp) {
          if (!err) {
            $scope.integrations.mailchimp_token = token;
            $translate('PROJECT.SAVE_SUCCESS').then(function (result) {
              App.toast(result, 3000);
            });
          }
          $scope.saving = false;
          $('.modal.open .modal-close').trigger('click');
        });
      };

      $scope.saveGoogleSearchConsole = function (token) {
        const data = {
          token: token
        };
        $scope.saving = true;
        Api.put('integrations/google-console', data, function (err, resp) {
          if (!err) {
            $scope.integrations.google_console = token;
            $translate('PROJECT.SAVE_SUCCESS').then(function (result) {
              App.toast(result, 3000);
            });
          }
          $scope.saving = false;
          $('.modal.open .modal-close').trigger('click');
        });
      };

      $scope.loadingAudience = false;
      $scope.onChangeMailChimpToken = function (token) {
        if (token) {
          $scope.loadingAudience = true;
          Api.get(`integrations/mailchimp/audience/list?token=${token}`, function (err, resp) {
            if (!err) {
              $scope.mailchimpList = resp.response.data.lists;
              $scope.loadingAudience = false;
            } else {
              $scope.loadingAudience = false;
              $translate('PROJECT.GET_MAILCHIMP_LIST_ERROR').then(function (result) {
                App.toast(result, 3000);
              });
            }
          });
        }
      };
    },

    footerMenu: function ($scope, Api, NgTableParams, ReqAndUpload, $q, $translate) {
      $scope.newlink = {};

      //  Change sort
      $scope.sort = function () {
        var sort = [];
        $('.collection-sortable li').each(function () {
          sort.push($(this).attr('id'));
        });
        Api.put('project/menu', {
          type: 'footer',
          sort: sort
        });
      };
      $scope.sortableOptions = {
        update: function (e, ui) {
          $scope.sort();
        }
      };

      // Add item
      $scope.add = function (newlink) {
        if (!newlink.title || !newlink.url) {
          $translate('PROJECT.LINK_ADD_INVALID_FIELDS').then(function (result) {
            App.toast(result, 3000);
          });
          return false;
        }
        newlink.type = 'footer';
        Api.post('project/menu', newlink, function (err, resp) {
          if (!err) {
            $scope.newlink = {};
            $scope.loadData('project/menu?type=footer', 'menu');
            $translate('PROJECT.LINK_ADD_SUCCESS').then(function (result) {
              App.toast(result, 3000);
            });
          }
        });
      };

      // Remove item
      $scope.remove = function (signature) {
        Api.delete(`project/menu/${signature}`, function (err, resp) {
          if (!err) {
            $scope.loadData('project/menu?type=footer', 'menu');
            $translate('PROJECT.LINK_DELETE_SUCCESS').then(function (result) {
              App.toast(result, 3000);
            });
          }
        });
      };
    },

    headerMenu: function ($scope, Api, NgTableParams, ReqAndUpload, $q, $translate) {
      $scope.newlink = {};

      //  Change sort
      $scope.sort = function () {
        var sort = [];
        $('.collection-sortable li').each(function () {
          sort.push($(this).attr('id'));
        });
        Api.put('project/menu', {
          type: 'header',
          sort: sort
        });
      };
      $scope.sortableOptions = {
        update: function (e, ui) {
          $scope.sort();
        }
      };

      // Add item
      $scope.add = function (newlink) {
        if (!newlink.title || !newlink.url) {
          $translate('PROJECT.LINK_ADD_INVALID_FIELDS').then(function (result) {
            App.toast(result, 3000);
          });
          return false;
        }
        newlink.type = 'header';
        Api.post('project/menu', newlink, function (err, resp) {
          if (!err) {
            $scope.newlink = {};
            $scope.loadData('project/menu?type=header', 'menu');
            $translate('PROJECT.LINK_ADD_SUCCESS').then(function (result) {
              App.toast(result, 3000);
            });
          }
        });
      };

      // Remove item
      $scope.remove = function (signature) {
        Api.delete(`project/menu/${signature}`, function (err, resp) {
          if (!err) {
            $scope.loadData('project/menu?type=header', 'menu');
            $translate('PROJECT.LINK_DELETE_SUCCESS').then(function (result) {
              App.toast(result, 3000);
            });
          }
        });
      };
    },

    homeMessage: function ($scope, Api) {
      $scope.loading = 1;
      $scope.contentCB = function () {
        $scope.loading = 0;
      };
    },

    footerMessage: function ($scope, Api) {
      $scope.loading = 1;
      $scope.contentCB = function () {
        $scope.loading = 0;
      };
    },

    header: function ($scope, Api, NgTableParams, ReqAndUpload, $q, $translate) {
      $scope.loading = 1;

      ace.require('ace/ext/language_tools');

      let beautify = ace.require('ace/ext/beautify');
      let dom = ace.require('ace/lib/dom');

      ace.require('ace/commands/default_commands').commands.push({
        name: 'Toggle Fullscreen',
        bindKey: 'F11',
        exec: function (editor) {
          let fullScreen = dom.toggleCssClass(document.body, 'fullScreen');
          dom.setCssClass(editor.container, 'fullScreen', fullScreen);
          editor.setAutoScrollEditorIntoView(!fullScreen);
          editor.resize();
        }
      });

      let editor = ace.edit('editor');

      editor.session.setMode('ace/mode/html');
      editor.setTheme('ace/theme/pastel_on_dark');
      editor.setOptions({
        enableBasicAutocompletion: true,
        enableSnippets: true,
        enableLiveAutocompletion: true,
        showPrintMargin: false,
        showDisplayIndentGuides: true,
        autoScrollEditorIntoView: true
      });

      $scope.contentCB = function () {
        $scope.loading = 0;
        editor.setValue($scope.project.header_content, 0);
        beautify.beautify(editor.session);
      };
      $scope.loadData('project/general_data', 'project', 'response', $scope.contentCB);
      $scope.saveData = function () {
        $scope.project.header_content = editor.getValue();
        let payload = $scope.project;
        delete payload._id;
        Api.put('project/general_data', payload, function (err, ret) {
          if (!err) {
            $translate('MESSAGES.OK_DEFAULT').then(function (result) {
              App.toast(result, 3000);
            });
          }
        });
      };
    },

    settings: function ($scope, Api, NgTableParams, ReqAndUpload, $q, $translate) {
      $scope.preSave = function (payload) {
        if (!payload.settings.policies.hasOwnProperty('content_type') || payload.settings.policies.content_type.length == 0) {
          $translate('PROJECT.SETTINGS_UPDATE_INVALID_PAYLOAD').then(function (result) {
            App.toast(result, 3000);
          });
          return 'ERROR';
        }

        if (!payload.settings.policies.course_creation_role) {
          $translate('PROJECT.SETTINGS_UPDATE_INVALID_COURSE').then(function (result) {
            App.toast(result, 3000);
          });
          return 'ERROR';
        }
      };
    },

    projectMonetization: function ($scope, Api, NgTableParams, ReqAndUpload, $q, $translate) {
      $scope.newUser = false;

      Api.get('project/monetization-account', function (err, ret) {
        if (!err) {
          $scope.newUser = ret.response.data;
        }
      });
      // Show user data from item select on suggest input
      $scope.preAddUserMonetization = function (user) {
        Api.get(`user/get/${user.id}`, function (err, data) {
          $scope.newUser = {
            account_id: user.accountId,
            user_id: data.response._id,
            user_name: data.response.name,
            user_email: data.response.email,
            user_slug: data.response.slug,
            user_image: data.response.image
          };
        });
      };

      $scope.save = function () {
        const data = {
          target_monetization_account_id: $scope.newUser.account_id
        };
        Api.put('project/monetization-account', data, function (err, ret) {
          if (!err) {
            $translate('MESSAGES.OK_DEFAULT').then(function (result) {
              App.toast(result, 3000);
            });
          }
        });
      };
    },

    projectSettingsNPS: function ($scope, Api, NgTableParams, ReqAndUpload, $q, $translate) {
      const ngInit = () => {
        Api.get('custom-survey-questions?show_disabled=false', function (err, resp) {
          if (!err) {
            $scope.questions = resp.response.data;
          }
        });
      };

      ngInit();

      $scope.saveQuestion = (item) => {
        Api.post('custom-survey-questions', item, function (err, resp) {
          if (!err) {
            $translate('MESSAGES.ARTICLE_SAVED').then(function (result) {
              App.toast(result, 3000);
            });
            Api.get('custom-survey-questions?show_disabled=false', function (err, resp) {
              if (!err) {
                $scope.questions = resp.response.data;
              }
            });
          } else {
            $translate('MESSAGES.FAIL_DEFAULT').then(function (result) {
              App.toastError(result, 3000);
            });
          }
        });
      };

      $scope.removeQuestion = (item) => {
        Api.delete(`custom-survey-questions/${item.id}`, function (err, resp) {
          if (!err) {
            $translate('MESSAGES.ARTICLE_DELETED').then(function (result) {
              App.toast(result, 3000);
            });
            Api.get('custom-survey-questions?show_disabled=false', function (err, resp) {
              if (!err) {
                $scope.questions = resp.response.data;
              }
            });
          } else {
            $translate('MESSAGES.FAIL_DEFAULT').then(function (result) {
              App.toastError(result, 3000);
            });
          }
        });
      };

      let updatingQuestions = false;
      $scope.updateQuestion = () => {
        if (updatingQuestions) clearTimeout(updatingQuestions);
        updatingQuestions = window.setTimeout(function () {
          var payload = {
            questions_ids_in_answering_order: []
          };
          $('.questions-sortable > div.questions-item').each(function () {
            const questObj = $(this);
            const questId = questObj.attr('data-questionid');
            if (questId) payload.questions_ids_in_answering_order.push(questId);
          });
          Api.put(`custom-survey-questions/project/answering-order`, payload, function (err, resp) {
            if (err) {
              $translate('GLOBAL.ERROR').then((result) => App.toastError(result, 5000));
            }
            ngInit();
          });
        }, 2000);
      };

      $scope.questionSortableOptions = {
        handle: '.handle',
        connectWith: '.questions-sortable',
        out: $scope.updateQuestion
      };
    }
  };
})();
